import BaseComponent from "./BaseComponent";
import Dropdown from "./Dropdown";
import Utility from "../utilities/Utility";
import ItemList from "./ItemList";
import Button from "./Button";
import ReactDOM from "react-dom";
import CustomScriptDialog from "../widgets/dialogs/CustomScriptDialog";
import map from "lodash/map";

export default class Function extends BaseComponent {
    /**
     * Function component for custom node; show corresponding component based on function type
     * @module Function
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.function = {};
    }

    /**
     * Set config proxy; change data model based on function type
     * @param {string} key
     * @param {Array|string} value
     */
    setConfig(key, value) {
        if (this.props.context.props.nodeTypeName === "Data Access" || this.props.context.props.nodeTypeName === "Data Access Completion") {
            this.props.context.props.config.customScript = value;
            this.updateContext(value);
        }
       else { if (this.props.functionType === "CUSTOM") {
            delete this.function.ref;
        } else {
            if (key === "ref") {
                const f = window.apm.knowledgeBase.getFunctions(value);
                this.function.arguments = [];
                // Load argument definitions
                if (f.parameters) {
                    for (var i = 0; i < f.parameters.length; i++) {
                        this.function.arguments.push({
                            argumentName: f.parameters[i].key,
                            type: "value",
                            value: f.parameters[i].value ? f.parameters[i].value : "null",
                            varName: null
                        });
                    }
                }
            }
            delete this.function.script;
        }
        this.function[key] = value;
        this.updateContext(this.function);
        if (key === "ref") {
            this.forceUpdate();
        }}
    }

    /**
     * Get current context value
     * @param {string} key
     * @returns {*}
     */
    getConfig(key) {
        return this.function[key];
    }

    componentWillMount() {
        if (this.props.value) {
            // create deep copy of props object   
            this.function = _.cloneDeep(this.props.value);
        }
    }

    /**
     * Get the function "argument" part for display
     * @returns {string}
     */
    getScriptHeader() {
        var serializedParams = "";
        const params = map(this.getConfig("arguments"), p => {
            if (p.type === "variable"||p.type==="parameter") {
                return p.argumentName + (p.varName ? " = {{" + p.varName + "}}" : "");
            }
            return p.argumentName + (p.value ? " = " + p.value : "");
        });
        if (params.length) {
            serializedParams = params.join(", ");
        }
        return "function (" + serializedParams + ") {";
    }

    /**
     * Get the function "closure" part for display
     * @returns {string}
     */
    getScriptFooter() {
        return "}";
    }

    /**
     * React render
     * @returns {*}
     */
    render() {
        if (this.props.functionType === "CUSTOM") {
            const applicationToolTip = "Parent Custom Node input types/values do not propagate to children.";
            const flowToolTip = "Canvas Custom Node input types/values do not propagate to parent or siblings.";
            const toolTip = this.props.context.id === this.props.context.props.parentComponentID ? applicationToolTip : flowToolTip;
            return (
                <div>
                    { this.props.context.props.nodeTypeName!=="Data Access"&&this.props.context.props.nodeTypeName!=="Data Access Completion"&&<ItemList label={this.getPropLabel("arguments")}
                        view={"functionArgument"}
                        context={this}
                        valKey={"arguments"}
                        value={this.getConfig("arguments")} readOnly={this.props.disabled}
                        tooltip={toolTip}
                    />}
                   
                    {this.props.context.props.nodeTypeName !== "Data Access" &&this.props.context.props.nodeTypeName!=="Data Access Completion"&& <ItemList label={this.getPropLabel("write_output_to")}
                        view={"return"}
                        context={this}
                        valKey={"outputs"}
                        value={this.getConfig("outputs")} readOnly={this.props.disabled}
                    />}
                       
                    <Button key={"edit"} disabled={false} label={this.props.disabled ? this.getPropLabel("view_script") : this.getPropLabel("edit_script")} wide={true} callback={() => {
                        window.apm.popup(this.getPropLabel("custom_function") + (this.props.context.name ?
                            " - " + this.props.context.name : ""),
                            '<div class="custom_script_container"></div>',
                            '<button class="w2ui-btn secondary" onclick="w2popup.close();">' + this.getPropLabel("close") + '</button> ' +
                            '<button class="w2ui-btn primary add-button">' + this.getPropLabel("save") + '</button> ',
                            [
                                ".custom_script_container",

                                () => {
                                    ReactDOM.render(<CustomScriptDialog
                                        context={this} />, $(".custom_script_container").get(0));
                                    $(".w2ui-popup").find(".add-button").on("click", function () {
                                        document.dispatchEvent(new CustomEvent("ev-dialog-add"));
                                    });

                                }
                            ]

                        );
                    }} />
                </div>
            );
        }
        if (this.props.functionType === "REUSEABLE") {
            var sel = -1;
            const val = this.function.ref ? this.function.ref : "";
            let options = window.apm.knowledgeBase.getFunctions();
            
            const selOptions = [];
            for (var i = 0; i < options.length; i++) {
                selOptions.push({ name: options[i].name, value: options[i].id });
            }
            for (var ds = 0; ds < selOptions.length; ds++) {
                if (selOptions[ds].value === val) {
                    sel = ds;
                    break;
                }
            }

            return (
                <div>
                  <Dropdown key={Utility.uuid4()}
                        label={this.getPropLabel("function")}
                        context={this}
                        valKey={"ref"}
                        optionName={"Select function"}
                        options={selOptions}
                        selection={sel}
                        readOnly={this.props.context.readOnly}
                    />
                  
                   <ItemList key={Utility.uuid4()}
                        label={this.getPropLabel("arguments")}
                        view={"functionArgument"}
                        context={this}
                        valKey={"arguments"}
                        value={this.getConfig("arguments")}
                        updateOnly={true}
                        readOnly={this.props.disabled}
                    />
                     
                    <ItemList label={this.getPropLabel("outputs")}
                        view={"return"}
                        context={this}
                        valKey={"outputs"}
                        value={this.getConfig("outputs")}
                        readOnly={this.props.disabled}
                    />
                    
                    {(sel !== -1) && (<Button key={"view"} label={this.getPropLabel("view_script")} wide={true} callback={() => {
                        window.apm.popup(this.getPropLabel("reusable_function"),
                            '<div class="custom_script_container"></div>',
                            '<button class="w2ui-btn primary" onclick="w2popup.close();">' + this.getPropLabel("close") + '</button> ',
                            [
                                ".custom_script_container",

                                () => {
                                    ReactDOM.render(<CustomScriptDialog
                                        context={this} />, $(".custom_script_container").get(0));

                                }
                            ]

                        );
                    }} />)}
                </div>
            );
        }
        return [];
    }
}
